import { createContext, Dispatch, SetStateAction } from 'react';

interface SidebarCtx {
  isSidebarMinimized: boolean;
  setIsSidebarMinimized: Dispatch<SetStateAction<boolean>>;
}

const SidebarContext = createContext<SidebarCtx>({
  isSidebarMinimized: false,
  setIsSidebarMinimized: () => false,
});

export default SidebarContext;
